export default __webpack_public_path__ + "static/equilibre_iphone_tablet-cut-cb1ff7bb388f08a2ab52950004d0bdb4.png";